import { render } from "./UserModulesDataTable.vue?vue&type=template&id=7bd8e738"
import script from "./UserModulesDataTable.vue?vue&type=script&lang=js"
export * from "./UserModulesDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__